import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/shared/presentation/components/ui/Button';
import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';
import { Select } from '@/shared/presentation/components/ui/Select';

import { CreateUserScreen } from './CreateUser';
import { UsersViewModel } from './Users.vm';

export const UsersScreen = observer(() => {
  const vm = useViewModel(UsersViewModel);

  const columns = useMemo(
    () => [
      {
        name: 'Codigo de Registro',
        selector: (row) => {
          return <Link to={`/admin/accounts/${row.registrationCode}`}>{row.registrationCode}</Link>;
        },
      },
      {
        name: 'Email',
        selector: (row) => row.email,
        sortable: true,
        filterable: true,
      },
      {
        name: 'Nome',
        selector: (row) => row.name,
        sortable: true,
        filterable: true,
      },
    ],
    [],
  );

  const actions = useMemo(() => [], []);

  const data = vm.users.map((user) => ({
    registrationCode: user.registrationCode,
    name: user.name,
    email: user.email,
  }));

  return (
    <Page
      title="Contas"
      subtitle={`Gerencie as contas de usuários do sistema`}
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar as contas."
      headerActions={() => (
        <Button
          icon="add"
          size="small"
          disabled={vm.isLoading}
          onClick={() => vm.openCreateModal()}
        >
          Adicionar
        </Button>
      )}
    >
      <DataTable
        isLoading={vm.isLoading}
        columns={columns}
        data={data}
        actions={actions}
        headerActions={
          <div style={{ display: `flex`, gap: '1rem' }}>
            <Select
              disabled={vm.isLoading}
              id="scope"
              label="Escopo:"
              options={vm.scopes.map((scope) => ({
                value: scope.guid,
                label: scope.name,
              }))}
              selected={vm.selectedScopeGuid}
              onChange={(value) => vm.setScope(value)}
            />
            <Select
              disabled={vm.isLoading}
              id="role"
              label="Papel:"
              options={vm.roles.map((role) => ({
                value: role.guid,
                label: role.name,
              }))}
              selected={vm.selectedRoleGuid}
              onChange={(value) => vm.setRole(value)}
            />
          </div>
        }
      />
      <CreateUserScreen />
    </Page>
  );
});
